import { lazy } from "react";

const routes = [
  {
    path: "/subPageOrgMapping",
    element: lazy(
      () => import("../../pages/ModulePersonalization/SubPageOrgMapping"),
    ),
  },
  {
    path: "/subPageOrgMapping/create",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubPageOrgMapping/create-editSubPageOrgMapping"),
    ),
  },
  {
    path: "/subPageOrgMapping/edit/:id",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubPageOrgMapping/create-editSubPageOrgMapping"),
    ),
  },
];

export default routes;
